<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>{{ themeId ? "Edit" : "Add New" }} Theme</h1>
  </div>
  <div *ngIf="!loading">
    <div class="themesWrapper">
      <form id="translation" [formGroup]="form">
        <label class="block-pointer">
          <span>Theme Name</span>
          <mat-form-field>
            <input type="text" matInput placeholder="Theme Name *" formControlName="name" maxlength="51" />
            <mat-error *ngIf="form.get('name')?.hasError('required')">Theme name is required</mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('maxlength')">Theme name must not exceed 50
              characters</mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('onlySpecialChars')">
              Theme name must not contain only special characters
            </mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('onlySpaces')">
              Theme name cannot be empty spaces
            </mat-error>
          </mat-form-field>
        </label>
        <label>
          <span>Choose Language</span>
          <mat-form-field>
            <mat-select formControlName="langId" placeholder="Language *">
              <mat-option *ngFor="let lang of languages" [disabled]="isLangSelected(lang.id)" [value]="lang.id">
                {{ lang.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('langId')?.hasError('required')">Language is required</mat-error>
          </mat-form-field>
        </label>
        <div class="category-and-add-row">
          <p class="add-all-text" [style.visibility]="!themeId ? 'visible' : 'hidden'">
            Add all {{ languages.length }} languages translations
          </p>
          <div [style.visibility]="
            !loading && (isEditing || themeTranslations.length < languages.length)
              ? 'visible'
              : 'hidden'
          ">
            <button (click)="addTheme()" type="button" class="add-button unblock-pointer">
              Add
            </button>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="themeTranslations.length" class="tableWrapper">
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Theme Name</th>
            <th>Language</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let theme of themeTranslations; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ theme.themeName }}</td>
            <td>
              {{ getLanguageName(theme.langId) }}
            </td>
            <td>
              <div class="actionWrapper">
                <div *ngIf="theme.langId !== 1" class="actionItem" (click)="removeTheme(i)">
                  <img src="../../../assets/images/icons/icon-delete.svg" alt="Delete" />
                </div>
                <div class="actionItem" (click)="editTheme(i)">
                  <img src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btnWrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="cmn-next-btn" (click)="saveTheme()"
        [disabled]="themeTranslations.length !== languages.length || isSubmitting">
        {{ themeId ? "Update" : "Save" }}
      </button>
    </div>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
</section>
